import { Attention } from '@icon-park/react'
import {
  Checkbox,
  CheckboxContainer,
  CheckboxLabel,
  CheckboxWrapper,
  ExclusionContainer,
  ExclusionDescription,
  ExclusionTitle,
  ValidationMessage,
  WarningIconWrapper,
} from './DataSourceExclusion.styles'

interface DataSourceExclusionProps {
  excludedDataSources: number[]
  onExclusionChange: (excludedDataSources: number[]) => void
}

const DATA_SOURCE_IDS = {
  SOCIAL_MEDIA: 1,
  PRESS: 2,
} as const

export function DataSourceExclusion({ excludedDataSources, onExclusionChange }: DataSourceExclusionProps): JSX.Element {
  const isSocialExcluded = excludedDataSources.includes(DATA_SOURCE_IDS.SOCIAL_MEDIA)
  const isPressExcluded = excludedDataSources.includes(DATA_SOURCE_IDS.PRESS)
  const bothExcluded = isSocialExcluded && isPressExcluded

  const handleToggle = (dataSourceId: number) => {
    const isCurrentlyExcluded = excludedDataSources.includes(dataSourceId)

    if (isCurrentlyExcluded) {
      onExclusionChange(excludedDataSources.filter((id) => id !== dataSourceId))
    } else {
      onExclusionChange([...excludedDataSources, dataSourceId])
    }
  }

  return (
    <ExclusionContainer>
      <ExclusionTitle>
        <WarningIconWrapper>
          <Attention size={20} />
        </WarningIconWrapper>
        Esta empresa NÃO terá classificação de Favorabilidade para:
      </ExclusionTitle>

      <ExclusionDescription>
        Selecione as fontes de dados que devem ser excluídas da classificação de favorabilidade. As abas correspondentes
        ficarão desativadas e as regras não serão obrigatórias. Pelo menos uma fonte deve estar ativa.
      </ExclusionDescription>

      <CheckboxContainer>
        <CheckboxWrapper $disabled={bothExcluded && !isSocialExcluded}>
          <Checkbox
            type="checkbox"
            checked={isSocialExcluded}
            onChange={() => handleToggle(DATA_SOURCE_IDS.SOCIAL_MEDIA)}
            disabled={bothExcluded && !isSocialExcluded}
          />
          <CheckboxLabel>Redes Sociais</CheckboxLabel>
        </CheckboxWrapper>

        <CheckboxWrapper $disabled={bothExcluded && !isPressExcluded}>
          <Checkbox
            type="checkbox"
            checked={isPressExcluded}
            onChange={() => handleToggle(DATA_SOURCE_IDS.PRESS)}
            disabled={bothExcluded && !isPressExcluded}
          />
          <CheckboxLabel>Imprensa</CheckboxLabel>
        </CheckboxWrapper>
      </CheckboxContainer>

      {bothExcluded && (
        <ValidationMessage $type="error">
          <Attention size={16} />
          Pelo menos uma fonte de dados deve estar ativa. Não é possível excluir todas as fontes.
        </ValidationMessage>
      )}

      {(isSocialExcluded || isPressExcluded) && !bothExcluded && (
        <ValidationMessage $type="warning">
          <Attention size={16} />
          {isSocialExcluded && isPressExcluded ?
            'Ambas as fontes estão excluídas. Pelo menos uma deve estar ativa.'
          : isSocialExcluded ?
            'Redes Sociais está excluída. As regras de favorabilidade não serão obrigatórias para esta fonte.'
          : 'Imprensa está excluída. As regras de favorabilidade não serão obrigatórias para esta fonte.'}
        </ValidationMessage>
      )}
    </ExclusionContainer>
  )
}
